import { render, staticRenderFns } from "./pc-input-date.vue?vue&type=template&id=63b61783&scoped=true&"
import script from "./pc-input-date.vue?vue&type=script&lang=ts&"
export * from "./pc-input-date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b61783",
  null
  
)

export default component.exports